import { OnboardingFlow } from "@/components/onboarding/OnboardingFlow";

const Onboarding = () => {
  return <OnboardingFlow />;
};

export default Onboarding;
